import React, { FC } from 'react'
import styles from './status-textEr.module.scss'
import {ArrowRightIcon} from "../../assets";

interface Props {
  color: 'gray' | 'blue' | 'green' | 'orange'
  text: string
}

const StatusTextEr: FC<Props> = (props) => {
  return (
    <div className={styles.wrapper}>
      <div className={`${styles.circle} ${styles[props.color]}`} />
      <p title={props.text} className={`${styles.text} ${styles[props.color]}`}>{props.text}</p>
    </div>
  )
}

export default StatusTextEr
